import { useEffect, useRef } from "react";
import setDocumentTitle from "@jnctn/webcore/ui-helpers/setDocumentTitle";

// Changes the document title
export default function useDocumentTitle(title: string, restore = false) {
  const previous = useRef(document.title);

  useEffect(() => {
    setDocumentTitle(title);
  }, [title]);

  useEffect(() => {
    const { current } = previous;
    return () => {
      if (restore && current) {
        setDocumentTitle(current);
      }
    };
  }, [restore]);
}
